module.exports = __webpack_public_path__ + "img/RX-Arcos-5.e93d62a2.png";